var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"money","category-name":"MONEY VOICE賞","category-intro":"専門家と個人投資家の本音でつくる金融情報メディア「MONEY VOICE」で2020年にご紹介した記事の中から、特に注目を集めたものをセレクトしました。"}})}
var staticRenderFns = []

export { render, staticRenderFns }